import BigNumber from "bignumber.js";
import { create } from "zustand";
const useBooksOrderStore = create((set)=>({
        revision: 0,
        deliveryFee: 0,
        originalPriceTotal: 0,
        amountTotal: 0,
        discountAmount: 0,
        payableAmount: 0,
        payMethod: "card",
        setItems: (items, isBooks)=>set((state)=>{
                if (!items) {
                    return {
                        items: undefined
                    };
                }
                const totals = {
                    originalPriceTotal: 0,
                    amountTotal: 0
                };
                const newItems = items.map((item)=>{
                    totals.originalPriceTotal += BigNumber(item.product.originPrice).multipliedBy(item.quantity).toNumber();
                    const subtotal = BigNumber(item.product.price).multipliedBy(item.quantity).toNumber();
                    totals.amountTotal += subtotal;
                    return {
                        ...item,
                        subtotal
                    };
                });
                const deliveryFee = isBooks ? BigNumber(totals.amountTotal).isGreaterThanOrEqualTo(30000) ? 0 : 2500 : 0;
                return {
                    items: newItems,
                    ...totals,
                    deliveryFee,
                    discountAmount: BigNumber(totals.originalPriceTotal).minus(BigNumber(totals.amountTotal)).toNumber(),
                    payableAmount: BigNumber(totals.amountTotal).plus(deliveryFee).toNumber()
                };
            }),
        removeItem: (cartItemId)=>set((state)=>{
                const newItems = [
                    ...state.items
                ];
                const idx = newItems.findIndex((param)=>{
                    let { id  } = param;
                    return cartItemId === id;
                });
                if (idx > -1) {
                    newItems.splice(idx, 1);
                }
                return {
                    items: newItems
                };
            }),
        setItemQuantity: (cartItemId, quantity)=>set((state)=>{
                const newItems = [
                    ...state.items
                ];
                const idx = newItems.findIndex((param)=>{
                    let { id  } = param;
                    return cartItemId === id;
                });
                if (idx > -1) {
                    newItems.splice(idx, 1);
                }
                return {
                    items: state.items.map((item)=>({
                            ...item,
                            quantity: cartItemId === item.id ? quantity : item.quantity
                        }))
                };
            }),
        setPayMethod: (payMethod)=>set((state)=>({
                    payMethod
                })),
        brandNewRevision: ()=>set((state)=>({
                    revision: new Date().getTime()
                }))
    }));
export default useBooksOrderStore;
